export class Reference {
	constructor(
		public readonly packageSize: number,
		public readonly historicProductDataViewDate: Date | null,
		public readonly referenceBasketVersion: string,
		public readonly priceComparisonFxDate: Date | null
	) {}
}
